// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListDiamond_reportDivider__1GgMt"};